// extracted by mini-css-extract-plugin
module.exports = {"role-admin":"styles_role-admin__3Gm3V","align-text":"styles_align-text__30ZVw","role-img":"styles_role-img__3W62i"};